import { Box, Chip, Stack } from "@mui/material"
import React, { useEffect, useState } from "react";

import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import { useDispatch } from "react-redux";
import {
    StartLoading,
    StopLoading,
} from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import { AGENT, TEAMS } from "../../../Services/Endpoint";
import { ShowError } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import { Params, useParams } from "react-router-dom";

interface MyComponentProps {
    sendMessageQuestions: (question: string) => void
    agentId?: string
    teamsId?: string
}


const AgentQuestions: React.FC<MyComponentProps> = (props) => {
    const { agentId, teamsId, apiKey } = useParams<Params>();
    const dispatch = useDispatch();
    const [questions, setQuestions] = useState([])


    useEffect(() => {
        if (props.agentId) {
            if (apiKey) {
                getQuestionsIframeAgent()
            } else {
                getQuestionsAgent();
            }
        }
    }, [agentId]);

    useEffect(() => {
        if (props.teamsId) {
            if (apiKey) {
                getQuestionsIframeMultiAgent()
            } else {
                getQuestionsMultiAgent();
            }
        }
    }, [teamsId]);

    const getQuestionsAgent = async () => {
        try {
            dispatch(StartLoading())
            const data = await BaseInstance.get(`${AGENT}/${props.agentId}/suggested-questions`).then(res => res?.data)
            setQuestions(data?.questions)
        } catch (err: any) {
            dispatch(ShowError(err?.response?.data?.statusText));
        } finally {
            dispatch(StopLoading())
        }
    }
    const getQuestionsIframeAgent = async () => {
        try {
            dispatch(StartLoading());
            const response = await fetch(
                `${AGENT}/${props.agentId}/suggested-questions`,
                {
                    method: "GET",
                    headers: {
                        "x-api-key": `${apiKey}`,
                        "Content-Type": "application/json",
                        Accept: "text/event-stream",
                    },
                    mode: "cors",
                    credentials: "same-origin",
                }
            )
            const data = await response.json();
            setQuestions(data?.questions);
        } catch (err: any) {
            dispatch(ShowError(err?.response?.data?.statusText));
        } finally {
            dispatch(StopLoading());
        }
    }


    const getQuestionsMultiAgent = async () => {
        try {
            dispatch(StartLoading())
            const data = await BaseInstance.get(`${TEAMS}/${props.teamsId}/get-suggested-questions`).then(res => res?.data)
            setQuestions(data?.questions)
        } catch (err: any) {
            dispatch(ShowError(err?.response?.data?.statusText));
        } finally {
            dispatch(StopLoading())
        }
    }
    const getQuestionsIframeMultiAgent = async () => {
        try {
            dispatch(StartLoading());
            const response = await fetch(
                `${TEAMS}/${props.teamsId}/get-suggested-questions`,
                {
                    method: "GET",
                    headers: {
                        "x-api-key": `${apiKey}`,
                        "Content-Type": "application/json",
                        Accept: "text/event-stream",
                    },
                    mode: "cors",
                    credentials: "same-origin",
                }
            )
            const data = await response.json();
            setQuestions(data?.questions);
        } catch (err: any) {
            dispatch(ShowError(err?.response?.data?.statusText));
        } finally {
            dispatch(StopLoading());
        }
    }

    const handleClick = (question: string) => {
        props.sendMessageQuestions(question)
    };

    return (
        <Box
            sx={{
                zIndex: 1,
                pb: 1,
                // background: "#fff",
            }}
        >
            <Stack
                direction="row"
                flexWrap="wrap"
                sx={{
                    flexWrap: "wrap",
                    gap: 1, // This helps maintain spacing when wrapping
                }}
            >
                {questions?.map((question: any, index) => (
                    <Chip
                        key={index}
                        label={question?.question || ""}
                        variant="outlined"
                        onClick={() => handleClick(question?.question || "")}
                        sx={{ background: "#fff" }}
                    />
                ))}


            </Stack>
        </Box >
    )
}

export default AgentQuestions